export const screenInfo = {
  ADD: ["Add Benefit Max Schedule Step", "RCBSD003"],
  CHANGE: ["Benefit Max Schedule Step Detail", "RCBSD002"],
};

export const formFields = [
  {
    section: "section 1",
    name: "bscScheduleName",
    label: "Schedule",
    fieldLabel: "BSC Schedule Name",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [1, 1],
  },
  {
    section: "section 1",
    name: "bscDescription",
    label: "Description",
    fieldLabel: "BSC Description",
    type: "text",
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [2, 1],
  },
  {
    section: "section 1",
    name: "bscBasis",
    label: "Basis",
    fieldLabel: "BSC Basis",
    type: "dropdown",
    dropdownCondition: "*Valid values",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [3, 1],
  },
  {
    section: "section 1",
    name: "bscStepCount",
    label: "Steps",
    fieldLabel: "BSC Step Count",
    type: "number",
    fractionDigits: 0,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99, message: "MAX_99" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [4, 1],
  },
  {
    section: "section 1",
    name: "bsdStepNumber",
    label: "Step Number",
    fieldLabel: "BSD Step Number",
    type: "number",
    fractionDigits: 0,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99, message: "MAX_99" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [5, 1],
  },
  {
    section: "section 1",
    name: "bsdAccumComponentCode",
    label: "Accum Component Code",
    fieldLabel: "BSD Accum Component Code",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [6, 1],
  },
  {
    section: "section 1",
    name: "bsdAccumWMadTimestmp",
    label: "After Adj Time",
    fieldLabel: "DSD Accum w/MAD Timestmp?",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [7, 1],
  },
  {
    section: "section 1",
    name: "bsdMbrBenefitAmount",
    label: "Benefit Individual",
    fieldLabel: "BSD Mbr Benefit Amount",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [8, 1],
  },
  {
    section: "section 1",
    name: "bsdFamBenefitAmount",
    label: "Benefit Family",
    fieldLabel: "BSD Fam Benefit Amount",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [9, 1],
  },
  {
    section: "section 1",
    name: "bsdPricingTableFlag",
    label: "Copay Patient Pay Table",
    fieldLabel: "BSD Pricing Table Flag",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [10, 1],
  },
  {
    section: "Copay Amount (Header)",
    name: "bsdBrandCopayAmount",
    label: "Brand",
    fieldLabel: "BSD Brand Copay Amount",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99999.99, message: "MAX_99999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [12, 1],
  },
  {
    section: "Copay Amount (Header)",
    name: "bsdGenericCopayAmount",
    label: "Generic",
    fieldLabel: "BSD Generic Copay Amount",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99999.99, message: "MAX_99999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [12, 2],
  },
  {
    section: "Copay Percent (Header)",
    name: "bsdBrandPercentAmt",
    label: "Brand",
    fieldLabel: "BSD Brand Percent Amt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [14, 1],
  },
  {
    section: "Copay Percent (Header)",
    name: "bsdGenericPercentAmt",
    label: "Generic",
    fieldLabel: "BSD Generic Percent Amt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [14, 2],
  },
  {
    section: "section 4",
    name: "bsdPercentBasis",
    label: "Percent Basis",
    fieldLabel: "BSD Percent Basis",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [15, 1],
  },
  {
    section: "section 4",
    name: "bsdCopayBenefitFlag",
    label: "Update",
    fieldLabel: "BSD Copay/Benefit Flag",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [16, 1],
  },
  {
    section: "section 4",
    name: "bsdCrossOver",
    label: "Cross Over",
    fieldLabel: "BSD Cross Over",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 1],
  },
  {
    section: "section 4",
    name: "bsdMessageCde",
    label: "Message Code",
    fieldLabel: "BSD Message Cde",
    type: "lookup",
    externalProgram: { default: "RCMSG002" },
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [
          {
            source: "bsdMessageCde",
            target: "code",
            legacy: "msgMessageCde"
          },
        ],
      },
    },
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [18, 1],
  },
  {
    section: "section 4",
    name: "bsdMessageType",
    label: "Message Type",
    fieldLabel: "BSD Message Type",
    type: "dropdown",
    dropdownCondition: "Valid Values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [18, 2],
  },
  {
    section: "section 4",
    name: "planCode",
    label: "Plan Override",
    fieldLabel: "Plan Code",
    type: "lookup",
    externalProgram: { default: "RCPLN018" },
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [
          { source: "planCode", target: "planCode",legacy:"planCode" },
          { source: "planEffDate", 
            resolver:"formatDateForPresto",
            legacy:"planEffDate",
            target: "planEffDate" },
          { source: "planName", target: "planName",legacy:"planName" },
        ],
      },
      appName: "ACCUMS",
      pageName: "PLAN_CODE",
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [19, 1],
  },

  {
    section: "section 4",
    name: "planEffDate",
    label: "From Date",
    fieldLabel: "Plan Eff Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [20, 2],
  },
  {
    section: "section 4",
    name: "planName",
    label: "",
    fieldLabel: "Plan Name",
    type: "text",
    options: {},
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [19, 3],
  },
  {
    section: "section 4",
    name: "bsdSendFlag",
    label: "Send",
    fieldLabel: "OPD Send Flag",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [21, 1],
  },
  {
    section: "section 4",
    name: "bsdIntPharmAndMedical",
    label: "Integrated Pharmacy and Medical",
    fieldLabel: "OPD Int Pharm and Medical",
    type: "dropdown",
    dropdownCondition: "Ben Max/Life Sch Int List",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [22, 1],
  },
  {
    section: "section 4",
    name: "bsdMaximumAmtDueInd",
    label: "Maximum Amount Due Ind",
    fieldLabel: "BSD Maximum Amt Due Ind",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [23, 1],
  },
  {
    section: "section 4",
    name: "bsdMaximumAmtDueAmt",
    label: "Maximum Amount Due",
    fieldLabel: "BSD Maximum Amt Due Amt",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [23, 2],
  },
  {
    section: "Audit Fields",
    name: "addDate",
    label: "Added",
    fieldLabel: "ADD Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [24, 1],
  },
  {
    section: "Audit Fields",
    name: "chgDate",
    label: "Changed",
    fieldLabel: "CHG Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [24, 2],
  },
  {
    section: "Audit Fields",
    name: "chgUserName",
    label: "User",
    fieldLabel: "CHG User Name",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [24, 3],
  },
];
